/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Allow_CameraInputs */

const en_mobile_scan_allow_camera = /** @type {(inputs: Mobile_Scan_Allow_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow camera`)
};

const es_mobile_scan_allow_camera = /** @type {(inputs: Mobile_Scan_Allow_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir cámara`)
};

/**
* | output |
* | --- |
* | "Allow camera" |
*
* @param {Mobile_Scan_Allow_CameraInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_allow_camera = /** @type {((inputs?: Mobile_Scan_Allow_CameraInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Allow_CameraInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_allow_camera(inputs)
	return en_mobile_scan_allow_camera(inputs)
});